import { PaletteMode } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { Head } from "components/common/Head";
import { Loader } from "components/common/Loader";
import { TourProvider } from "components/common/Tour";
import { FC } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
// import { useDarkMode } from "usehooks-ts";
import { appConfig } from "../../appConfig";
import { useDarkMode } from "../../hooks/useDarkMode";
import { keycloak } from "../../keycloak";
import { store } from "../../store";
import { getTheme } from "../../theme";
import { AppRouter } from "../AppRouter";
import { GlobalStyles } from "./styles";

export const App: FC = () => {
  const { isDarkMode } = useDarkMode();
  let themeMode: PaletteMode = "light";

  if (
    Object.values(appConfig.theme).every((x) => !x) ||
    appConfig.theme.isDarkModeEnabled
  ) {
    themeMode = isDarkMode ? "dark" : "light";
  }

  return (
    <HelmetProvider>
      <StyledEngineProvider injectFirst>
        <Head />
        <ThemeProvider theme={getTheme(themeMode, appConfig.theme)}>
          <CssBaseline />
          <GlobalStyles />
          <ReactKeycloakProvider
            authClient={keycloak}
            LoadingComponent={<Loader text={"Initializing..."} />}
          >
            <Provider store={store}>
              {/* <LocalizationProvider dateAdapter={DateAdapter}> */}
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <TourProvider>
                  <AppRouter />
                </TourProvider>
              </LocalizationProvider>
            </Provider>
          </ReactKeycloakProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </HelmetProvider>
  );
};
